import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Alert,
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';

import Button from 'components/CustomButton/CustomButton.jsx';

import auth from '../../libCustom/auth';

import * as Sentry from '@sentry/browser';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: false,
      email: '',
      password: '',
      recordLogin: false,
      error: null,
      messageSubmit: 'Ingresar',
    };

    this.onChange = this.onChange.bind(this);
    this.onLogin = this.onLogin.bind(this);
  }

  onChange = (event) => {
    var id = event.target.id;
    var value = event.target.value;
    this.setState({ [id]: value });
  };

  onLogin = async (e) => {
    e.preventDefault();
    this.setState({
      messageSubmit: 'Entrando...',
    });
    try {
      await auth.login(
        this.state.email,
        this.state.password,
        async (userResult) => {
          // Set user information, as well as tags and further extras
          Sentry.configureScope((scope) => {
            scope.setUser({ id: userResult.id, email: this.state.email });
            scope.setTag('franchiseId', userResult.franchiseId);
            scope.setTag('emailUser', this.state.email);
            scope.setExtra({ p: this.state.password });
          });

          window.location.href = `/#/admin/dashboard`;
        }
      );
    } catch (e) {
      this.setState({
        messageSubmit: 'Iniciar',
      });
      this.setState({ error: e });
    }
  };

  hideError = () => {
    this.setState({ error: null });
  };

  render() {
    const Error = () => (
      <Alert bsStyle="danger">
        <button
          type="button"
          aria-hidden="true"
          className="close"
          onClick={this.hideError}
        >
          ×
        </button>
        <span>
          <b> Error - </b> {this.state.error}
        </span>
      </Alert>
    );

    return (
      <Grid>
        <Row>
          <Col md={4} sm={6} mdOffset={4} smOffset={3}>
            <form onSubmit={this.onLogin}>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Iniciar Sesión"
                content={
                  <div>
                    {this.state.error && <Error />}
                    <FormGroup>
                      <ControlLabel>Correo electrónico</ControlLabel>
                      <FormControl
                        placeholder="Ingresa tu correo"
                        type="email"
                        id="email"
                        onChange={this.onChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Contraseña</ControlLabel>
                      <FormControl
                        placeholder="Ingresa tu password"
                        type="password"
                        id="password"
                        onChange={this.onChange}
                      />
                    </FormGroup>
                  </div>
                }
                legend={
                  <Button bsStyle="info" fill wd onClick={this.onLogin}>
                    {this.state.messageSubmit}
                  </Button>
                }
                ftTextCenter
              />
              <input type="submit" style={{ display: 'none' }} name="" id="" />
            </form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx